import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const Alonline = ({ navigation, route }: any) => {
  const {
    values,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey, toatalexemptions
  } = route.params

  const personalstore = usePersonalStore()
  const intializestore = useInitializeStore()
  const { postalonline, loading } = useFormsStore()



  let noclaimvalue
  let personal1500
  let personal3000

  switch (values.Claimnopersonalexemption) {
    case 1:
      noclaimvalue = 0
      break
    default:
      noclaimvalue = 1
  }

  switch (values.FilingSeparately) {
    case 1:
      personal1500 = 'S'
      break
    case 2:
      personal1500 = 'MS'
      break
    default:
      personal1500 = ''
  }
  switch (values.ClaimingHeadofFamily) {
    case 1:
      personal3000 = 'M'
      break
    case 2:
      personal3000 = 'H'
      break
    default:
      personal3000 = ''
  }



  const handlesubmit = async (signatureDataURL: string) => {
    const data = {
      completeOnline: true,
      essuserKey: intializestore.initializeData.userkey,
      entityId: personalstore.personalData?.entityId,
      claimPersonalExemption: values.Claimnopersonalexemption == '' || Number(values?.Claimnopersonalexemption) == 1 ? null : values.Claimnopersonalexemption,
      filingSeparately: values.FilingSeparately,
      claimingHeadofFamily: values.ClaimingHeadofFamily,
      dependents: values.dependents,
      additionalamount: values.Additionalamount ? values.Additionalamount : null,
      totalExemptions: toatalexemptions,
      formKey: essUserOnBoardingFormKey,
      essObKey: essUserOnBoardingKey,
      sign: signatureDataURL
    }
    const response = await postalonline(data)
    if (response?.success) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    }
    else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'AL Withholding Taxation'}
          />
        </View>
      </View>
      <SignatureFormView
        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
        essUserOnBoardingKey={essUserOnBoardingKey}
        isSubmitting={loading}
        onPrevious={() =>
          navigation.navigate('AlinformationForm', {
            essUserOnBoardingFormKey,
            essUserOnBoardingKey,
            values,
            mode: "online",

          })
        }
        onSubmit={handlesubmit}
      />

    </>
  )
}
export default Alonline
